import { Status } from "../../Config/Status.js";
import { Options } from "../../Config/Options.js";

import BusinessVideoGsap from "./BusinessVideoGsap.js";

const Home = {
  preinit(){
  },
  init() {
  },
  load() {
    BusinessVideoGsap.init();
  },
  resize() {
  },
  resizeW() {
  },
  scroll() {
  },
  orientation() {
  }
}


export default Home;